import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import * as utils from "../../../assets/utils";

import Fr_Input from "../../../lib/ui/fr_input";
import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Wnd_Info from "../../../lib/ui/wnd_info";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";
import Fr_Cal from "../../../lib/ui/fr_cal";
import Lang from "../../../lib/lang";
import Td_Sel from "../../../lib/ui/td_sel";

function TabPanel(props) {
    const { children, value, index, ctx, ...other } = props;
    function tab_change(val) {
        //alert(newValue);
        ctx.setState({ix: val});
    };
    function tab_style(val) {
        var css = {};
        css.height = "30px";
        css.lineHeight = "30px";
        css.background = "#fff";
        css.borderBottom = "1px #ccc solid";
        css.color = "#ccc";
        if(val == ctx.state.ix) {
            css.color = "#080";
            css.borderBottom = "2px #080 solid";
        }
        return css;
    }

    return (
        <div
            className="flex ripple text-center" onClick={() => tab_change(index)} style={ tab_style(index) }
            {...other}
        >
            {children}
        </div>
    );
}

class Prd_Edit extends React.Component {
  constructor(props, context) {
    super(props);

    ///this.pos = props.store.pos;

    this.state = {};
    this.state.mpa = [];

    this.state.gnr = "001";
    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];
      this.state.mtval = [
          {id: 'PLU', text: 'PRODUKT'},
          {id: 'INFO', text: 'INFORMATION'}
      ];

      this.state.ix = 0;
      this.state.selrow = {};
      this.state.msg = {};
      this.state.cols = {};
    this.state.mpo = {};
    if(props.wnds.mpo) this.state.mpo = props.wnds.mpo;
      //alert(JSON.stringify(this.state.mpo));
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      //if(!this.props.wnds.tdo) this.task_init();
      //this.mnu_mp();
  }

    task_init() {
        var tdo = {};
        tdo.typ = "";
        tdo.id = "";
        tdo.text = "";
        tdo.reg = "";
        tdo.status = "";
        //alert(JSON.stringify(rso));
        this.setState({ tdo: tdo });
        return;
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 275;
        return css;
    }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) {
            if(this.state.sortdir) css.color = "#800";
            else css.color = "#080";
        }
        return css;
    }
    row_style(row) {
        var srow = this.state.selrow;

        var css = {};
        if(srow == row) {
            css.background = "#080";
            css.color = "#fff";
        }
        return css;
    }

    wnd_close = () => {
        if(this.props.wnds.cb) {
            this.props.wnds.cb(this.props.ctx);
        }
        else this.props.ctx.setState({ wnds: {} });
    };
    mt_change (e) {
        const value = e.target.value;
        var mpo = this.state.mpo;
        mpo.prdtyp = value;
        this.setState({mpo: mpo});
    }
    anm_change (e) {
        const value = e.target.value;
        var mpo = this.state.mpo;
        mpo.anm = value;
        this.setState({mpo: mpo});
    }

    val_save(id, val) {
        var mpo = this.state.mpo;
        mpo[id] = val;
        this.setState({ mpo: mpo });
        return;
    }
    sel_row(row) {
        var srow = this.state.selrow;
        if(srow == row) {
            this.setState({selrow: {}});
        }
        else this.setState({selrow: row});
    }
    sel_row_fkn(row, sel) {
        if(sel.fkn == "open") {
        }
    }
    mnu_mp() {
        var self = this;
        var prm = {};
        prm.req = "dsi.dsi_mp.mp_mnu";
        prm.mnuid = this.state.mpo.mnuid;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rca));

                self.setState({ mpa: ret.rca });
                //self.setState({ rva: ret.rca });
                self.syncTb("mpaTable");
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var rva = self.state.rva;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }

        if(typ == "ank") {
            if(sortdir) rva.sort((a,b) => (a.gsb00.r0ankdatum < b.gsb00.r0ankdatum) ? 1 : ((b.gsb00.r0ankdatum < a.gsb00.r0ankdatum) ? -1 : 0));
            else rva.sort((a,b) => (a.gsb00.r0ankdatum > b.gsb00.r0ankdatum) ? 1 : ((b.gsb00.r0ankdatum > a.gsb00.r0ankdatum) ? -1 : 0));
        }
        self.setState({ rva: rva, sortid: typ, sortdir: sortdir });
    }
    th_icon(typ) {
        var cls = "";
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;
        if(sortid == typ)
        {
            if(sortdir) cls = "fa fa-caret-up";
            else cls = "fa fa-caret-down";
        }
        return cls;
    }
  prd_save() {
    var self = this;
    var prm = {};
    prm.req = "dsi.dsi_mp.mp_upd";
    prm.mpo = this.state.mpo;

    net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret));

            var prm = {};
            prm.req = "pos.plu_anm.mp_upd";
            prm.mpo = this.state.mpo;

            return net.sio_req(prm);
        })
        .then(function(ret){
            //alert(JSON.stringify(ret));
            if(ret.ok == "000") {
                self.setState({ msg: {ok: true, text: "Sparad ..."} });
                setTimeout(function(){
                    self.setState({msg: {} });
                    if(self.props.wnds.cb) {
                        self.props.wnds.cb(self.props.ctx);
                    }
                    else self.props.ctx.setState({ wnds: {} });
                    return;
                }, 1000);
            }
        })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  prd_del() {
    var self = this;
    var prm = {};
    prm.req = "dsi.dsi_mp.mp_del";
    prm.mpo = this.state.mpo;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({ msg: {ok: true, text: "Borttagen"} });
            setTimeout(function(){
                self.setState({msg: {} });
                  if(self.props.wnds.cb) {
                      self.props.wnds.cb(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    pluanm_get () {
        var self = this;

        var avd = this.state.mpo.plu.substring(0,2);
        var plunr = this.state.mpo.plu.substring(2,6);
        var key = avd + plunr;

        var prm = {};
        prm.req = "pos.pos_pluanm.anm_get";
        prm.avd = avd;
        prm.pluid = key;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rco));
                var mpo = self.state.mpo;
                mpo.pluanm = ret.rco.anm.trim();
                mpo.pluanm = mpo.pluanm.cdi2txt();
                self.setState({ mpo: mpo, pao: ret.rco });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    pluanm_upd () {
        var self = this;

        var anm = this.state.mpo.anm;
        anm = anm.txt2cdi();
        var avd = this.state.mpo.plu.substring(0,2);
        var plunr = this.state.mpo.plu.substring(2,6);

        var pao = {};
        pao.typ = "A";
        pao.avd = avd;
        pao.plunr = plunr;
        pao.anm = anm;
        pao.lopnr = "";

        var prm = {};
        prm.req = "pos.pos_pluanm.anm_upd";
        prm.pao = pao;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rca));
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    pluanm_del () {
        var self = this;

        var avd = this.state.mpo.plu.substring(0,2);
        var plunr = this.state.mpo.plu.substring(2,6);

        var pao = {};
        pao.typ = "A";
        pao.avd = avd;
        pao.plunr = plunr;
        pao.anm = "";
        pao.lopnr = ""

        var prm = {};
        prm.req = "pos.pos_pluanm.anm_del";
        prm.pao = this.state.pao;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rca));
            var pbo = self.state.pbo;
            pbo.pluanm = "";
            self.setState({pbo: pbo});
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    pluanm_clear () {
        var self = this;
        var mpo = this.state.mpo;
        mpo.anm = "";
        this.setState({mpo: mpo});
    }

  render() {
    //if(!this.props.show) return "";
    var title = this.props.title;
    if(!title) title = "Resurs";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_90 flex-col" style={ this.dlg_style() } >

        <div className="mx_content flex">

        <div className="mx_h01">
            <div>PRODUKT : { this.state.mpo.plu } - { utils.toNum( this.state.mpo.text ) }</div>
        </div>
            <div className="divider_orange"></div>

            <form className="cdi_f03">
                <div className="flex-row">
                    <Fr_Input label="Meny ID" className="text-left w150" text={this.state.mpo.mnuid} getValue={(e)=> this.val_save("mnuid", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="PLU ID" className="text-left w150" text={this.state.mpo.plu} getValue={(e)=> this.val_save("plu", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Text" className="text-left w350" text={this.state.mpo.text} getValue={(e)=> this.val_save("text", e) } />
                </div>
                <div className="flex-row">
                    <div className="form-group flex-row flex">
                        <span className="header">Produkt typ</span>
                        <select value={this.state.mpo.prdtyp} className="form-control w250" onChange={(e) => this.mt_change(e)}>
                            { this.state.mtval.map((row, key) =>
                                <option key={key} value={row.id}>{row.text}</option>
                            )}
                        </select>
                    </div>
                </div>
                <div className="flex-row">
                    <Fr_Input label="Sortering" className="text-left w150" text={this.state.mpo.sort} getValue={(e)=> this.val_save("sort", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Status" className="text-left w150" text={this.state.mpo.status} getValue={(e)=> this.val_save("status", e) } />
                </div>

                <div className="divider_green"></div>
                <div className="flex-row">
                    <div className="flex flex-column" style={{padding: "0px 5px"}}>
                        <span className="header">Produkt information</span>
                        <textarea className="form-control" maxLength="512" rows="10" value={this.state.mpo.anm} onChange={(e) => this.anm_change(e)}></textarea>
                    </div>
                </div>
                <div className="flex-row px-3">
                    <div className="web-link" onClick={() => this.pluanm_get() }>Hämta</div>
                    <div className="flex"></div>
                    <div className="web-link" onClick={() => this.pluanm_clear() }>Rensa</div>
                    <div className="flex"></div>
                    <div className="web-link" onClick={() => this.pluanm_del() }>Ta Bort</div>
                    <div className="flex"></div>
                    <div className="web-link" onClick={() => this.pluanm_upd() }>Spara</div>
                </div>
            </form>
        </div>


        <div className="mx_foot flex-row">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-red w250" onClick={() => this.prd_del() } >
                TA BORT
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-red w250" onClick={() => this.prd_save() } >
                SPARA
            </button>
        </div>

        </div>

        <Wnd_Error msg={this.state.msg} ctx={this} />
        <Wnd_Ok msg={this.state.msg} ctx={this} />
        <Wnd_Info msg={this.state.msg} ctx={this} />
        <Wnd_Confirm msg={this.state.msg} ctx={this} />
      </div>
	;
	return html;
  };
}

export default Prd_Edit;